<template>
  <div class="results-vue">
    <div class="row">
      <div class="col-md-3">
        <!-- info container left -->
        <div class="portlet light results-box" :class="passed ? 'pass':'fail'">
          <div class="portlet-title">
            <div class="caption">
              <span class="caption-subject bold uppercase">Αποτελεσματα</span>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-xs-4 text-center">
                <div class="result-svg"></div>
              </div>
              <div class="col-xs-8 result-text">
                <h3>{{ passed ? 'Πέρασες!' : 'Aπερρίφθει' }}</h3>

                <button class="btn btn-sm btn-circle blue btn-block" @click="$emit('restartTest')">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Επανάληψη
                </button>
              </div>
            </div>

            <!-- facebook box -->
            <div class="text-center results-fb-page" style="margin: 20px -20px -20px -20px;">
              <div
                class="fb-page"
                :data-href="`https://www.facebook.com/${facebookID}`"
                data-show-posts="false"
                data-small-header="true"
                data-adapt-container-width="true"
                data-hide-cover="false"
                data-show-facepile="true"
              ></div>
            </div>
          </div>
        </div>

        <!-- <div class="alert alert-success" v-if="saved==='saved'">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Οι απαντήσεις σου αποθηκεύτηκαν με επιτυχία!
                </div>

                <div class="alert alert-info" v-if="saved==='saving'">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Οι απαντήσεις σου αποθηκεύονται...
                </div>

                <div class="alert alert-danger" v-if="saved==='error'">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Σφάλμα! Δεν μπορέσαμε να αποθηκεύσουμε τις απαντήσεις σου, προσπαθούμε ξανά...
                </div>

                <div class="alert alert-warning" v-if="saved===false">
                    <i class="fa fa-times" aria-hidden="true"></i> Τα αποτελέσματα δεν αποθηκεύονται για αυτό το τεστ.
        </div>-->
      </div>

      <div class="col-md-9">
        <!-- stats -->
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption">
              <span class="caption-subject bold uppercase">στατιστικα</span>
            </div>
          </div>
          <div class="portlet-body">
            Λάθος: {{ wrongCount }}
            <progress-bar :percentage="100*wrongCount/totalCount" color="danger"></progress-bar>
            Σωστά: {{ correctCount }}
            <progress-bar :percentage="100*correctCount/totalCount" color="success"></progress-bar>
          </div>
        </div>

        <!-- question list -->
        <div class="results-list">
          <div v-if="wrongCount">
            <h3>Λάθος Απαντήσεις ({{ wrongCount }})</h3>
            <question-list :questionList="wrongQuestions" :testResults="true"></question-list>
          </div>

          <div class="spacer" v-if="correctCount && wrongCount" style="margin-top: 100px"></div>

          <div v-if="correctCount">
            <h3>Σωστές Απαντήσεις ({{ correctCount }})</h3>
            <question-list :questionList="correctQuestions" :testResults="true"></question-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from "../ProgressBar.vue";
import ProgressBarStacked from "../ProgressBarStacked.vue";
import QuestionList from "../question-list/QuestionList.vue";
import queryString from "query-string";

export default {
  data() {
    return {
      saved: "saving",
      timeoutId: null,
      retries: 0,
      facebookID: ""
    };
  },
  props: [
    "wrongQuestions",
    "correctQuestions",
    "totalCount",
    "correctCount",
    "wrongCount",
    "answeredCount",
    "category",
    "saveResults",
    "type"
  ],
  components: { ProgressBarStacked, ProgressBar, QuestionList },
  methods: {
    sendResults() {
      if (!this.saveResults) {
        this.saved = true;
        return;
      }
      const answers = {
        correct: this.correctQuestions.map(q => q.originalId),
        wrong: this.wrongQuestions.map(q => q.originalId)
      };
    }
  },
  computed: {
    passed() {
      let counts = { 1: 1, 2: 1, 3: 1, 4: 1, 6: 24, 7: 24, 8: 2 };
      return this.category
        ? this.wrongCount <= counts[this.category]
        : this.wrongCount <= 1;
    }
  },
  created() {
    const parsed = queryString.parse(location.search);
    this.facebookID = parsed.facebook_id;
  },
  mounted() {
    try {
      FB.XFBML.parse();
    } catch (e) {}
    this.sendResults();
    this.timeoutId = setTimeout(() => {
      if (this.saved === "saving") this.saved = "error";
    }, 120000);
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  }
};
</script>